import { gql } from "@apollo/client";

const DELETE_DEDUCTION_BACKUP_DOCUMENT = gql`
  mutation DeleteDeductionBackupDocument($params: DeleteDeductionBackupDocumentParams!) {
    deleteDeductionBackupDocument(params: $params) {
      documentIds
      remittanceItemId
    }
  }
`;

export default DELETE_DEDUCTION_BACKUP_DOCUMENT;
